import { createContext, useContext } from 'react';
export const useLogViewerContext = () => useContext(LogViewerContext);
export const LogViewerContext = createContext(null);
export const LogViewerToolbarContext = createContext(null);
//# sourceMappingURL=LogViewerContext.js.map